module.exports = __webpack_public_path__ + "img/collection-hover.e6ece515.svg";